// Remontées, lot R1 (cf-677) : une erreur du navigateur part au journal `signals` (POST /api/signals/client).
// Jamais bloquant, jamais d'erreur levée ; rien sans session (le serveur exige un utilisateur connecté) ;
// au plus 5 envois par chargement de page, une même erreur une seule fois ; la page est envoyée en MOTIF
// (identifiants remplacés par « :id », sans query ni ancre : ils peuvent porter un jeton ou un e-mail).
import axios from "axios";

const MAX_PER_LOAD = 5;
const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
let sent = 0;
const seen = new Set();

export function pagePattern(pathname = "") {
  return String(pathname).split(/[?#]/)[0].split("/").map((part) => (UUID.test(part) || /^\d+$/.test(part) ? ":id" : part)).join("/");
}

export function reportSignal(code, error, extra = {}, { backendUrl = process.env.REACT_APP_BACKEND_URL || "", post = axios.post } = {}) {
  try {
    const auth = axios.defaults.headers.common?.Authorization;
    if (!auth || sent >= MAX_PER_LOAD) return false;
    const message = String(error?.message || error || "").slice(0, 300);
    const key = `${code}|${message}`;
    if (seen.has(key)) return false;
    seen.add(key);
    sent += 1;
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    const project = path.match(/^\/projects\/([0-9a-f-]{36})/i);
    const body = {
      code,
      message,
      stack: String(error?.stack || "").slice(0, 2000),
      component_stack: String(extra.componentStack || "").slice(0, 1000),
      page: pagePattern(path),
      project_id: project ? project[1] : null,
      build: String(process.env.REACT_APP_BUILD_ID || "dev").slice(0, 60),
    };
    const pending = post(`${backendUrl}/api/signals/client`, body);
    if (pending && typeof pending.catch === "function") pending.catch(() => {});
    return true;
  } catch {
    return false;
  }
}

// Erreurs hors React (script, promesse rejetée sans catch) ; installé une fois depuis index.js
export function installGlobalErrorReporting(target = typeof window !== "undefined" ? window : null) {
  if (!target || target.__cfSignalsInstalled) return;
  target.__cfSignalsInstalled = true;
  target.addEventListener("error", (event) => reportSignal("window_error", event?.error || event?.message));
  target.addEventListener("unhandledrejection", (event) => reportSignal("unhandled_rejection", event?.reason));
}

export function _resetForTests() {
  sent = 0;
  seen.clear();
}
